import { PaymentTypeTag } from "./Payment/PaymentTypeTag"
import { AchStatusBadge } from "./Payment/AchStatusBadge"
import { css } from "@emotion/react"
import { Icon } from "source/shared/components"
import { arrayOf, shape, string } from "prop-types"

export const PaymentHistory = ({
  payments,
  totalAmount,
  label = "Payments",
}) => {
  return (
    <div css={paymentHistoryStyles}>
      <details className="paymentHistory__dropdown">
        <summary>
          <div className="d-f ai-c jc-sb fw-500">
            <span className="d-f ai-c g-1">
              <span>{label}</span>
              <Icon
                symbol="general#down-chevron"
                className="c-tint2 fs-5 paymentHistory__dropdown-closed-icon"
              />
              <Icon
                symbol="general#up-chevron"
                className="c-tint2 fs-5 paymentHistory__dropdown-opened-icon"
              />
            </span>
            <span>{totalAmount}</span>
          </div>
        </summary>
        <div className="d-f fd-c g-1 pt-1">
          {payments?.map((payment) => (
            <div key={payment.id} className="d-f ai-c jc-sb pl-2">
              <span>
                <PaymentTypeTag payment={payment} />
              </span>
              <span className="d-f ai-c g-1">
                {payment.instrument === "ACH" &&
                  (payment.status === "failed" ||
                    payment.status === "pending") && (
                    <AchStatusBadge status={payment.status} />
                  )}
                <span>{payment.amount || payment.failedAmount}</span>
              </span>
            </div>
          ))}
        </div>
      </details>
    </div>
  )
}

PaymentHistory.propTypes = {
  payments: arrayOf(
    shape({
      id: string.isRequired,
      amount: string.isRequired,
      instrument: string.isRequired,
      ccLastFour: string,
      ccCardType: string,
      description: string.isRequired,
      status: string,
    }),
  ).isRequired,
  totalAmount: string.isRequired,
  label: string,
}

const paymentHistoryStyles = css`
  .paymentHistory__dropdown {
    summary {
      list-style: none;
      cursor: pointer;
    }
    summary::-webkit-details-marker {
      display: none;
    }
  }

  .paymentHistory__dropdown-opened-icon {
    display: none;
  }
  .paymentHistory__dropdown-closed-icon {
    display: none;
  }

  details[open] .paymentHistory__dropdown-opened-icon {
    display: inline;
  }
  details:not([open]) .paymentHistory__dropdown-closed-icon {
    display: inline;
  }
`
